import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router';
import { api } from '../../lib/api.ts';
import { UserInviteForm, UsersGrid } from '../../components/UsersGrid.tsx';

/** 플랫폼 › 운영자 계정 (플랫폼 테넌트 사용자, 역할 platform_admin 고정) */
export function OperatorsPage() { return <UsersGrid base="/platform/operators" queryKey="platform-operators" invitePath="/platform/operators/invite" operator title="플랫폼 · 운영자 계정" note="플랫폼 운영자는 모두 platform_admin 역할입니다. 자기 자신과 마지막 활성 운영자는 비활성화할 수 없습니다." />; }
export function OperatorInvitePage() { return <UserInviteForm base="/platform/operators" backTo="/platform/operators" operator description="플랫폼 운영자를 초대합니다. 초대받은 운영자가 비밀번호·MFA 를 설정하면 활성화됩니다." />; }

function useTenantName(id: string) { return useQuery({ queryKey: ['platform-tenant-name', id], queryFn: () => api<{ name: string; slug: string }>(`/platform/tenants/${id}`), select: (t) => `${t.name} (${t.slug})` }); }
/** 플랫폼 › 테넌트 상세 › 사용자: 테넌트 계정 관리 (초대·역할·부서·상태·MFA·세션·잠금) */
export function TenantUsersPage() {
  const { id = '' } = useParams(); const name = useTenantName(id);
  return (
    <div>
      <Link to={`/platform/tenants/${id}`} className="page-back">← {name.data ?? '테넌트'}</Link>
      <UsersGrid base={`/platform/tenants/${id}/users`} queryKey={`platform-tenant-users-${id}`} invitePath={`/platform/tenants/${id}/users/invite`} rolesPath={`/platform/tenants/${id}/users`} deptsPath={`/platform/tenants/${id}/departments`} title={`${name.data ?? ''} 사용자`} note="플랫폼 운영자의 변경은 이 테넌트의 접속기록과 플랫폼 활동 로그에 남고 테넌트 관리자에게 메일로 통지됩니다. 마지막 활성 테넌트 관리자는 내리거나 비활성화할 수 없습니다." />
    </div>
  );
}
export function TenantUserInvitePage() {
  const { id = '' } = useParams();
  return <UserInviteForm base={`/platform/tenants/${id}/users`} backTo={`/platform/tenants/${id}/users`} deptsPath={`/platform/tenants/${id}/departments`} rolesPath={`/platform/tenants/${id}/roles`} description="플랫폼 운영자가 이 테넌트의 사용자를 초대합니다. 초대 메일의 발신자는 PRISM 운영팀으로 표시됩니다." />;
}
